/**
 * Nombre y mensaje legal de la plataforma.
 * MIRAI ABILITY LAB® – Plataforma Inteligente de Evaluación y Diagnóstico del Talento Estudiantil.
 */

export const PLATFORM_NAME = 'MIRAI ABILITY LAB® – Plataforma Inteligente de Evaluación y Diagnóstico del Talento Estudiantil.';

export const PLATFORM_NAME_SHORT = 'MIRAI ABILITY LAB®';

export const PLATFORM_LEGAL_MESSAGE = {
  title: PLATFORM_NAME,
  paragraphs: [
    'Plataforma en trámite de registro ante el Instituto Mexicano de la Propiedad Industrial (IMPI) y el Instituto Nacional del Derecho de Autor (INDAUTOR).',
    'Uso institucional con fines educativos, de evaluación y diagnóstico.',
    'Queda prohibida su reproducción total o parcial sin autorización expresa de los titulares.',
  ],
};

/** Texto para pies de página en PDFs */
export const PLATFORM_PDF_FOOTER = `Documento generado automáticamente por ${PLATFORM_NAME_SHORT} – Confidencial`;
